import { Controller } from '@hotwired/stimulus'

// Modal shell around the report_note_modal turbo-frame. The frame's content
// (see admin/report_notes/_modal_form) carries the `form` target; the modal
// shows/hides itself based purely on whether that target is present, so a
// turbo stream that empties the frame (successful create/update/destroy)
// automatically closes the modal with no extra coordination.
export default class extends Controller {
  static targets = ['overlay', 'form']

  formTargetConnected(element) {
    this.overlayTarget.classList.remove('hidden')
    // Focus the body textarea, not the date input — focusing the date
    // field would pop the flatpickr calendar open over the fresh modal.
    const input = element.querySelector('textarea')
    if (input) input.focus()

    this.onKeydown = (event) => {
      if (event.key === 'Escape') this.close()
    }
    document.addEventListener('keydown', this.onKeydown)
  }

  formTargetDisconnected() {
    if (this.hasFormTarget) return

    this.overlayTarget.classList.add('hidden')
    if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown)
  }

  close() {
    const frame = this.element.querySelector('turbo-frame#report_note_modal')
    if (!frame) return

    frame.removeAttribute('src')
    frame.innerHTML = ''
  }

  backdropClose(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  stop(event) {
    event.stopPropagation()
  }
}
